// extracted by mini-css-extract-plugin
module.exports = {"mainPage":"CurriculumDetails_mainPage__2hNxx","body":"CurriculumDetails_body__WVjk2"};